<template>
  <div
    id="case-study-map-main"
    :class="{ 'has-mobile-bottom-banner': viewMode === 'vertical' }"
  >
    <div class="view-mode">
      <button
        type="button"
        class="view-mode__button"
        :class="{ 'view-mode__button--active': viewMode === 'region' }"
        @click="handleClickViewMode('region')"
      >
        Region
      </button>
      <button
        type="button"
        class="view-mode__button"
        :class="{ 'view-mode__button--active': viewMode === 'vertical' }"
        @click="handleClickViewMode('vertical')"
      >
        Vertical
      </button>
      <button
        type="button"
        class="view-mode__button"
        :class="{ 'view-mode__button--active': viewMode === 'product' }"
        @click="handleClickViewMode('product')"
      >
        Product
      </button>
    </div>
    <div v-if="viewMode === 'region'" class="region-space" />
    <media :query="{ maxWidth: 1080 }">
      <filter-list
        v-if="viewMode === 'region' && regionList"
        ref="regionFilterList"
        :items="regionList"
        :current-item="currentRegionItem"
        @click="handleClickRegionItem"
      />
    </media>
    <filter-list
      v-if="viewMode === 'vertical' && currentVertical"
      :items="verticalList"
      :current-item="currentVertical"
      @click="handleClickVerticalItem"
    />
    <filter-list
      v-if="viewMode === 'product' && currentProductCategory"
      :items="productCategories"
      :current-item="currentProductCategory"
      @click="handleClickProductCategoryItem"
    />
    <div class="map-section">
      <media :query="{ minWidth: 1081 }">
        <div>
          <img
            src="/theme/rbFront/img/w/case-study/bg-case-study-map.png"
            alt=""
          />
          <template v-for="region in regionList">
            <map-continent
              v-if="filterRegionList(region)"
              :key="region.code"
              :region="region"
              :view-mode="viewMode"
              :vertical="currentVertical.name"
              :product-category="currentProductCategory.name"
              @click:item="handleClickMapContinentItem"
              @click:title="handleClickMapContinentTilte"
            />
          </template>
        </div>
      </media>

      <!-- Mobile -->
      <media
        :query="{ maxWidth: 1080 }"
        @media-enter="mobileMediaEnter"
        @media-leave="mobileMediaLeave"
      >
        <div
          class="map-pinch-area"
          :style="{
            width: `${paneWidth}px`,
            height: `${paneHeight}px`,
          }"
        >
          <!-- <PinchScrollZoom
            :width="paneWidth"
            :height="paneHeight"
            :scale="scale"
            :min-scale="minScale"
            :max-scale="maxScale"
            :content-height="paneHeight"
            @scaling="scalingHandler"
            @dragging="draggingHandler"
          > -->
          <div
            class="map-content"
            :style="{
              width: `${mapContentWidth}px`,
              height: `${mapContentHeight}px`,
              transform: `scale(${mapContentRatio})`,
            }"
          >
            <template v-for="region in regionList">
              <mobile-map-continent
                v-if="filterRegionList(region)"
                :key="region.code"
                :current-scale="paneCurrent.scale"
                :current-region="currentRegionItem.code"
                :content-ratio="mapContentRatio"
                :region="region"
                :view-mode="viewMode"
                :vertical="currentVertical.name"
                :product-category="currentProductCategory.name"
                @click:title="handleClickMobileMapContinentTilte"
              />
            </template>
            <img
              id="mobile-map-image"
              src="/theme/rbFront/img/w/case-study/mobile/map-image.png"
            />
          </div>
          <!-- </PinchScrollZoom> -->
          <!-- <Zoomer
            @click:zoom-in="handleClickZoomIn"
            @click:zoom-out="handleClickZoomOut"
          /> -->
          <bottom-sheet
            v-model="sheetState"
            :default-state="'half'"
            :region="currentRegionItem"
          >
            <MapList
              v-if="regionList && currentRegionItem"
              :items="regionList"
              :region="currentRegionItem.code"
              :region-name="currentRegionItem.name"
              :view-mode="viewMode"
              :vertical="currentVertical"
              :product-category="currentProductCategory"
              :ga4-text="ga4Title"
              @click:close="handleClickListPopupClose"
              @click:video="handleClickDetailPopupVideo"
              @change:region="handleChangeListRegion"
            />
          </bottom-sheet>
        </div>
      </media>
      <div
        v-if="viewMode === 'vertical' && currentVertical"
        class="banner-wrapper"
      >
        <banner
          :img-src="currentVertical.image"
          :img-alt="currentVertical.title"
          :url="currentVertical.url"
          :head-text="'Vertical Showroom Tour'"
          :ga4-text="ga4Title"
          :title="currentVertical.title"
        />
      </div>
      <div
        v-if="viewMode === 'region'"
        class="banner-wrapper banner-wrapper--region"
      >
        <banner
          :img-src="'Virtual-showroom-tour-vertical-showroom.jpg'"
          :img-alt="ga4Title"
          :url="'/dc/vertical_category'"
          :ga4-text="ga4Title"
          :head-text="ga4Title"
        />
      </div>
    </div>
    <!-- 20250516 요청 건: Contact Us 플로팅 버튼 삭제 요청 -->
    <!-- <a class="i2b-button" @click="handleClickInquiry">
      <img
        src="/theme/rbFront/img/w/case-study/btn_inquiry.png"
        alt="inquiry to buy"
      />
    </a> -->
    <detail-popup
      v-if="currentMapContinentItem"
      :item="currentMapContinentItem"
      :left="mapContinentPosition.left"
      :top="mapContinentPosition.top"
      style="z-index: 2"
      @click:close="handleClickDetailPopupClose"
      @click:video="handleClickDetailPopupVideo"
    />
    <VideoPopup
      v-if="visibleVideoPlayer"
      :item="currentVideoItem"
      @click:close="handleClickVideoPopupClose"
    />
    <ListPopup
      v-if="visibleListPopup && regionList && currentRegionItem"
      :items="regionList"
      :region="currentRegionItem.code"
      :region-name="currentRegionItem.name"
      :view-mode="viewMode"
      :vertical="currentVertical"
      :product-category="currentProductCategory"
      :ga4-text="ga4Title"
      @click:close="handleClickListPopupClose"
      @click:video="handleClickDetailPopupVideo"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import axios from 'axios'
import Media from 'vue-media'
// import PinchScrollZoom, { PinchScrollZoomEmitData } from "@coddicat/vue-pinch-scroll-zoom";
import bottomSheet from "./components/mobile/BottomSheet"
import FilterList from './components/FilterList'
import MapContinent from './components/MapContinent'
import MobileMapContinent from './components/mobile/MapContinent'
import DetailPopup from './components/DetailPopup'
import VideoPopup from './components/VideoPopup'
import ListPopup from './components/ListPopup'
import MapList from './components/mobile/List'
import Banner from './components/Banner'
// import Zoomer from './components/mobile/Zoomer'

export default {
  name: 'App',
  components: {
    FilterList,
    MapContinent,
    MobileMapContinent,
    DetailPopup,
    VideoPopup,
    ListPopup,
    MapList,
    Banner,
    Media,
    // Zoomer,
    // PinchScrollZoom,
    bottomSheet,
  },
  data() {
    return {
      regionList: [
        {
          name: 'Europe',
          code: 'europe',
          left: 556,
          top: 206,
          leftVw: 36.2111,
          topVw: 13.6056,
          leftMVw: 587,
          topMVw: 148,
          maxNameWidth: 0,
          mode: '',
          direction: 'right',
          items: [],
        },
        {
          name: 'North America',
          code: 'NA',
          left: 202,
          top: 274,
          leftVw: 13.6278,
          topVw: 18.2278,
          leftMVw: 230,
          topMVw: 274,
          maxNameWidth: 0,
          mode: 'vertical',
          direction: 'right',
          items: [],
        },
        {
          name: 'South Korea',
          code: 'korea',
          left: 1208,
          top: 372,
          leftVw: 79.6889,
          topVw: 24.4333,
          leftMVw: 903,
          topMVw: 295,
          maxNameWidth: 53,
          mode: 'vertical',
          direction: 'left',
          items: [],
        },
        {
          name: 'Middle East & Africa',
          code: 'MEA',
          left: 627,
          top: 426,
          leftVw: 41.0417,
          topVw: 28.1833,
          leftMVw: 558,
          topMVw: 430,
          maxNameWidth: 95,
          mode: 'vertical',
          direction: 'right',
          items: [],
        },
        {
          name: 'Asia',
          code: 'asia',
          left: 970,
          top: 372,
          leftVw: 63.8611,
          topVw: 24.3333,
          leftMVw: 781,
          topMVw: 351,
          maxNameWidth: 30,
          mode: 'vertical',
          direction: 'right',
          items: [],
        },
        {
          name: 'CIS',
          code: 'CIS',
          left: 1018,
          top: 107,
          leftVw: 67.1944,
          topVw: 6.93056,
          leftMVw: 750,
          topMVw: 122,
          maxNameWidth: 30,
          mode: '',
          direction: 'left',
          items: [],
        },
        {
          name: 'Global',
          code: 'global',
          left: 56,
          top: 30,
          leftVw: 3.68889,
          topVw: 1.38333,
          leftMVw: 84,
          topMVw: 87,
          maxNameWidth: 46,
          mode: '',
          direction: 'right',
          items: [],
        },
        {
          name: 'LATAM',
          code: 'latam',
          left: 420,
          top: 564,
          leftVw: 27.6278,
          topVw: 38.2278,
          leftMVw: 340,
          topMVw: 544,
          maxNameWidth: 0,
          mode: 'vertical',
          direction: 'right',
          items: [],
        },
      ],
      verticalList: [
        {
          name: 'Corporate',
          url: '/dc/vertical_showroom/?page=lobby',
          title: 'Lobby',
          image: 'Virtual-showroom-tour-lobby.jpg',
          listBanner: 'Virtual-showroom-tour-lobby.jpg',
        },
        {
          name: 'Public Space',
          url: '/dc/vertical_showroom/?page=outdoor',
          title: 'Outdoor',
          image: 'Virtual-showroom-tour-outdoor.jpg',
          listBanner: 'Virtual-showroom-tour-outdoor.jpg',
        },
        {
          name: 'Hospitality',
          url: '/dc/vertical_showroom/?page=hotel',
          title: 'Hotel Guest Room',
          image: 'Virtual-showroom-tour-hotel-guest-room.jpg',
          listBanner: 'Virtual-showroom-tour-hotel-guest-room.jpg',
        },
        {
          name: 'Retail',
          url: '/dc/vertical_showroom/?page=lfs_outsidethestore',
          title: 'Luxury Flagship Store',
          image: 'Virtual-showroom-tour-luxury-flagship-store.jpg',
          listBanner: 'Virtual-showroom-tour-luxury-flagship-store.jpg',
        },
        {
          name: 'Education',
          url: '/dc/vertical_showroom/?page=class',
          title: 'K-12 Classroom',
          image: 'Virtual-showroom-tour-k12-classroom.jpg',
          listBanner: 'Virtual-showroom-tour-k12-classroom.jpg',
        },
        {
          name: 'Transportation',
          url: '/dc/vertical_showroom/?page=metro',
          title: 'Metro',
          image: 'Virtual-showroom-tour-metro.jpg',
          listBanner: 'Virtual-showroom-tour-metro.jpg',
        },
        {
          name: 'Government',
          url: '/dc/vertical_showroom/?page=control',
          title: 'Control Room',
          image: 'Virtual-showroom-tour-control-room.jpg',
          listBanner: 'Virtual-showroom-tour-control-room.jpg',
        },
        {
          name: 'General',
          url: '/dc/vertical_category',
          title: 'Vertical Showroom',
          image: 'Virtual-showroom-tour-vertical-showroom.jpg',
          listBanner: 'Virtual-showroom-tour-vertical-showroom.jpg',
        },
      ],
      productCategories: [
        {
          name: 'LED Signage',
        },
        {
          name: 'Digital Signage',
        },
        // {
        //   name: 'OLED Signage',
        // },
        {
          name: 'Commercial TV',
        },
      ],
      currentMapContinentItem: null,
      currentMapContinentElement: null,
      currentMapContinentDirection: null,
      currentVideoItem: null,
      mapContinentPosition: { left: 0, top: 0 },
      visibleVideoPlayer: false,
      visibleListPopup: false,
      currentRegionItem: { name: '' },
      currentVertical: { name: '' },
      currentProductCategory: { name: '' },
      viewMode: 'region',
      zoomSize: 0.5,
      scale: 0.5,
      minScale: 1,
      maxScale: 5,
      paneWidth: 0,
      paneContentHeight: 0,
      paneCurrent: {
        scale: 1,
      },
      sheetState: 'half',
      showroomActive: false,
      mapContentWidth: 1080,
      mapContentHeight: 612,
      list: null,
    }
  },
  computed: {
    ...mapState('config', {
      feetMagnification: 'feetMagnification',
      magnification: 'magnification',
    }),
    paneHeight() {
      return this.paneWidth * 0.567
    },
    mapContentRatio() {
      return this.paneWidth / this.mapContentWidth
    },
    ga4Title() {
      if (this.viewMode === 'vertical') {
        return `Vertical Showroom Tour ${this.currentVertical.title}`
      } else {
        return 'Experience Virtual Showroom Tour'
      }
    },
  },
  watch: {
    viewMode: {
      handler() {
        this.handleClickDetailPopupClose()
      },
    },
    currentRegionItem: {
      handler() {
        this.handleClickDetailPopupClose()
      },
    },
    currentVertical: {
      handler() {
        this.handleClickDetailPopupClose()
        this.setLastestRegionForVertical()
      },
    },
    currentProductCategory: {
      handler() {
        this.handleClickDetailPopupClose()
        this.setLastestRegionForProductCategory()
      },
    },
    sheetState: {
      handler(value) {
        if (value === 'open') {
          this.htmlOverflowHidden()
        } else {
          this.htmlOverflowVisible()
        }
      },
    },
  },
  async created() {
    let response = null
    if (process.env.NODE_ENV === 'production') {
      response = await axios.get(`/lgcms/board/case-map/caseMapList`)
    } else {
      response = await axios.get(`/data/list.json`)
    }
    if (response.status === 200) {
      this.list = response.data
      this.regionList.forEach((region) => {
        response.data.forEach((item) => {
          if (region.name === item.region) {
            region.items.push(item)
          }
        })
      })
      this.regionList.forEach(region => {
        region.items.sort((a, b) => {
          if (a.isMainThumb && !b.isMainThumb) {
            return -1
          } else if (!a.isMainThumb && b.isMainThumb) {
            return 1
          } else {
            return 0
          }
        })
      })
    }
  },
  mounted() {
    document.addEventListener('click', this.mapviewClickEventListener)
    window.addEventListener('resize', this.mapviewResizeEventListener)
    this.paneWidth = window.innerWidth
    setTimeout(() => {
      if (document.getElementById('mobile-map-image')) {
        this.paneContentHeight = document.getElementById('mobile-map-image').clientHeight
      }
    }, 500)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.mapviewClickEventListener)
    document.removeEventListener('resize', this.mapviewResizeEventListener)
    // this.htmlOverflowVisible()
  },
  methods: {
    ...mapMutations('config', {
      setMagnification: 'setMagnification',
      setCurrentResolution: 'setCurrentResolution',
    }),
    handleClickZoomIn() {
      this.scale = this.scale + this.zoomSize
      if (this.scale > this.maxScale) {
        this.scale = this.maxScale
      }
    },
    handleClickZoomOut() {
      this.scale = this.scale - this.zoomSize
      if (this.scale < this.minScale) {
        this.scale = this.minScale
      }
    },
    convVW(number, baseWidth) {
      return (number / baseWidth) * 100
    },
    scalingHandler(e) {
      this.paneCurrent = e
    },
    draggingHandler() {
      // console.log(e)
    },
    handleClickVerticalClose() {
      this.showroomActive = false
    },
    handleClickMapContinentItem(element, item, direction) {
      this.currentMapContinentElement = element
      this.currentMapContinentItem = item
      this.currentMapContinentDirection = direction
    },
    mapviewClickEventListener(event) {
      if (event.target.className === 'map-continent__thumbnail') {
        this.mapContinentPosition.left = this.calcMapContinentLeft()
        this.mapContinentPosition.top = this.calcMapContinentTop() + 7
      }
    },
    mapviewResizeEventListener() {
      if (this.currentMapContinentItem) {
        this.mapContinentPosition.left = this.calcMapContinentLeft() + 10
        this.mapContinentPosition.top = this.calcMapContinentTop()
      }
      this.paneWidth = window.innerWidth
      if (document.getElementById('mobile-map-image')) {
        this.paneContentHeight = document.getElementById('mobile-map-image').clientHeight
      }
    },
    calcMapContinentLeft() {
      if (this.currentMapContinentDirection === 'right') {
        return window.pageXOffset + this.currentMapContinentElement.getBoundingClientRect().left + this.currentMapContinentElement.clientWidth
      } else {
        return (window.pageXOffset + this.currentMapContinentElement.getBoundingClientRect().left) - (document.querySelector('.detail-popup').clientWidth)
      }
    },
    calcMapContinentTop() {
      return (window.pageYOffset + this.currentMapContinentElement.getBoundingClientRect().top ) - (document.querySelector('.detail-popup').clientHeight / 2)
    },
    handleClickDetailPopupClose() {
      this.currentMapContinentItem = null
    },
    handleClickMapContinentTilte(region) {
      this.handleClickDetailPopupClose()
      this.currentRegionItem = region
      this.visibleListPopup = true
      // this.htmlOverflowHidden()
    },
    // TODO
    handleClickMobileMapContinentTilte(region) {
      this.currentRegionItem = region
      this.regionList.forEach((item, index) => {
        if(item.code === region.code) {
          if (this.$refs.regionFilterList) {
            this.$refs.regionFilterList.goto(index)
          }
        }
      })
      this.sheetState = 'open'
    },
    handleClickListPopupClose() {
      this.visibleListPopup = false
      // this.htmlOverflowVisible()
    },
    handleChangeListRegion(regionCode) {
      this.regionList.forEach((item, index) => {
        if(item.code === regionCode) {
          this.currentRegionItem = item
          if (this.$refs.regionFilterList) {
            this.$refs.regionFilterList.goto(index)
          }
        }
      })
    },
    handleClickDetailPopupVideo(item) {
      if (!item.videoUrl) {
        return
      }
      window.dataLayer.push({
        event: 'watch_video',
        video_url: item.videoUrl
      });
      this.currentVideoItem = item
      this.visibleVideoPlayer = true
      // this.htmlOverflowHidden()
    },
    handleClickVideoPopupClose() {
      this.currentVideoItem = null
      this.visibleVideoPlayer = false
      // this.htmlOverflowVisible()
    }, 
    handleClickViewMode(viewMode) {
      this.viewMode = viewMode
      if (viewMode === 'vertical') {
        this.currentVertical = this.verticalList[0]
        this.setLastestRegionForVertical()
      } else if (viewMode === 'product') {
        this.currentProductCategory = this.productCategories[0]
        this.setLastestRegionForProductCategory()
      } else {
        this.setDefaultRegion()
      }
    },
    htmlOverflowHidden() {
      document.querySelector('html').style.overflow = 'hidden'
    },
    htmlOverflowVisible() {
      document.querySelector('html').style.overflow = ''
    },
    filterRegionList(region) {
      if (this.viewMode === 'vertical') {
        let hasVerticalCount = 0
        region.items.forEach((item) => {
          if (item.vertical === this.currentVertical.name) {
            hasVerticalCount++
          }
        })
        return hasVerticalCount ? true : false
      } else if(this.viewMode === 'product') {
        let hasProductCategoryCount = 0
        region.items.forEach((item) => {
          item.recommendedProduct.forEach((prd) => {
            if (prd.productCategory1 === this.currentProductCategory.name) {
              hasProductCategoryCount++
            }
          })
        })
        return hasProductCategoryCount ? true : false
      } else {
        return true
      }
    },
    handleClickRegionItem(value) {
      this.currentRegionItem = value

    },
    handleClickVerticalItem(value) {
      this.currentVertical = value
    },
    handleClickProductCategoryItem(value) {
      this.currentProductCategory = value
    },
    setLastestRegionForVertical() {
      const items = this.list.filter(item => item.vertical === this.currentVertical.name)
      const orderedItems = items.sort((a, b) => new Date(b.crtDate) - new Date(a.crtDate))
      this.setLastestRegion(orderedItems)
    },
    setLastestRegionForProductCategory() {
      const items = []
      this.list.forEach((item) => {
        let hasProductCategoryCount = 0
        item.recommendedProduct.forEach((product) => {
          if (product.productCategory1 === this.currentProductCategory.name) {
            hasProductCategoryCount++
          }
        })
        if (hasProductCategoryCount) {
          items.push(item)
        }
      })
      const orderedItems = items.sort((a, b) => new Date(b.crtDate) - new Date(a.crtDate))
      this.setLastestRegion(orderedItems)
    },
    setLastestRegion(items) {
      if (items[0]) {
        this.regionList.forEach((item) => {
          if (item.name === items[0].region) {
            this.currentRegionItem = item
          }
        })
      }
    },
    setDefaultRegion() {
      this.currentRegionItem = this.regionList[0]
    },
    mobileMediaEnter() {
      this.setDefaultRegion()
      setTimeout(() => {
        this.handleClickZoomIn()
      }, 500)
    },
    mobileMediaLeave() {
      this.showroomActive = false
    },
    handleClickInquiry() {
      window.dataLayer.push({
        event: 'start_inquiry',
      })
      window.location.href = '/support/inquiry'
    },
  },
}
</script>

<style lang="scss" scoped>
@function convVW($number, $base-width) {
  @return calc((($number / $base-width) * 100) * 1vw);
}

#case-study-map-main {
  max-width: 1440px;
  @media only screen and (max-width: 1080px) {
    position: relative;
  }
  &.has-mobile-bottom-banner {
    @media only screen and (max-width: 1080px) {
      padding-bottom: calc(((120 / 720) * 100) * 1vw);
    }
  }
}
.view-mode {
  padding: 52px 0 0;
  @media only screen and (max-width: 1080px) {
    padding: calc(((52 / 720) * 100) * 1vw) calc(((30 / 720) * 100) * 1vw) 0;
  }
  &__button {
    font-size: 18px;
    width: 110px;
    height: 36px;
    line-height: 36px;
    border: solid 1px #333;
    border-radius: 20px;
    margin-right: 12px;
    box-sizing: border-box;
    color: #333;
    @media only screen and (max-width: 1080px) {
      width: 90px;
      height: 32px;
      line-height: 32px;
      font-size: 16px;
      margin-right: 8px;
    }
    &--active {
      border: 0;
      color: #fff;
      background-color: #fd312e;
      font-weight: 400;
    }
  }
}
.region-space {
  height: 116px;
  @media only screen and (max-width: 1080px) {
    height: 0;
  }
}
.map-section {
  position: relative;
  // height: 904px;
  img {
    width: 100%;
  }
}

.map-pinch-area {
  @media only screen and (max-width: 1080px) {
    margin-top: 30px;
  }
}

.map-content {
  position: relative;
  transform-origin: 0px 0px;
}

.i2b-button {
  display: block;
  position: fixed;
  z-index: 98;
  cursor: pointer;
  bottom: 100px;
  right: 100px;
  img {
    width: 100%;
  }
  @media screen and (max-width: 1199px) {
    width: 65px;
    bottom: 80px;
    right: 16px;
  }
  @media only screen and (max-width: 1080px) {
    z-index: 100;
    bottom: 9px;
  }
}
.banner-wrapper {
  position: absolute;
  right: 0;
  top: -74px;
  @media only screen and (max-width: 1080px) {
    top: auto;
    right: auto;
    bottom: 0;
    left: 0;
    transform: translateY(calc(100% + 20px));
    margin-top: 20px;
    padding: 20px;
  }
  &--region {
    @media only screen and (max-width: 1080px) {
      display: none;
    }
  }
}

/deep/ .showroom-button {
  position: absolute;
  right: calc(((30 / 720) * 100) * 1vw);
  top: calc(((52 / 720) * 100) * 1vw);
  @media only screen and (max-width: 1080px) {
    transform: translateY(50%);
  }
}
</style>
